import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=28cdae5d&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cdae5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cdae5d')) {
      api.createRecord('28cdae5d', component.options)
    } else {
      api.reload('28cdae5d', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=28cdae5d&scoped=true&", function () {
      api.rerender('28cdae5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27UlqKdOEUFEZ/JS/comp/Accordion.vue"
export default component.exports